import React from 'react';

import MuiButton from '@material-ui/core/Button';
import { withStyles } from '@material-ui/core/styles';
import ArrowBackIosIcon from '@material-ui/icons/ArrowBackIos';
import ArrowForwardIosIcon from '@material-ui/icons/ArrowForwardIos';

import clsx from 'clsx';
import PropTypes from 'prop-types';

import styles from './styles';

export function Button(props) {
  const { className, classes, children, hasArrowRight, hasArrowLeft, customEndIcon, customStartIcon, ...other } = props;
  const { iconOnly, startArrow, endArrow, ...classesRest } = classes;

  const endIcon =
    customEndIcon || hasArrowRight ? customEndIcon || <ArrowForwardIosIcon data-testid='forward-arrow-icon' /> : null;
  const startIcon =
    customStartIcon || hasArrowLeft ? customStartIcon || <ArrowBackIosIcon data-testid='back-arrow-icon' /> : null;

  return (
    <MuiButton
      data-testid='button'
      color='primary'
      variant='contained'
      disableElevation
      classes={classesRest}
      className={clsx(className, {
        [classes.iconOnly]: !children && Boolean(hasArrowLeft || hasArrowRight),
      })}
      endIcon={endIcon}
      startIcon={startIcon}
      {...other}
    >
      {children}
    </MuiButton>
  );
}

Button.propTypes = {
  className: PropTypes.string,
  classes: PropTypes.object,
  /** Contents of button */
  children: PropTypes.node,
  /** Adds default arrow right of content */
  hasArrowRight: PropTypes.bool,
  /** Adds default arrow left of content */
  hasArrowLeft: PropTypes.bool,
  /** Customize icon right of content */
  customEndIcon: PropTypes.node,
  /** Customize icon left of content */
  customStartIcon: PropTypes.node,
};

export default withStyles(styles)(Button);
